import { render, staticRenderFns } from "./qrcodegamepriceconfig.vue?vue&type=template&id=74b73f4a&scoped=true"
import script from "./qrcodegamepriceconfig.vue?vue&type=script&lang=js"
export * from "./qrcodegamepriceconfig.vue?vue&type=script&lang=js"
import style0 from "./qrcodegamepriceconfig.vue?vue&type=style&index=0&id=74b73f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b73f4a",
  null
  
)

export default component.exports